export const LOCALES = ['fi', 'en', 'sv']
